import MultiPinMapPreview from '@/components/common/MultiPinMapPreview';
import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

export default observer(function ShowResultAfterUploadFile() {
    // hooks
    const { t } = useTranslation();

    // store
    const {
        modalStore: { showAlertModal, hideModal },
        itemStore: { validData, invalidData }
    } = useStore();

    // インポート結果の配置マップ (spec §2-4)。
    // import レスポンスの validData は API raw 形式 (snake_case) で
    // latitude / longitude / title / hidden_on_map を持つ。
    const pins = (validData ?? [])
        .map((item: any) => ({
            latitude: parseFloat(item?.latitude),
            longitude: parseFloat(item?.longitude),
            label: item?.title,
            hidden: item?.hidden_on_map === true
        }))
        .filter(p => Number.isFinite(p.latitude) && Number.isFinite(p.longitude));
    const hiddenCount = pins.filter(p => p.hidden).length;

    return (
        <>
            <div>
                {t('words_title.upload_excel_success')}
                <span className='text-active ml-1'>{validData.length}</span>
                {hiddenCount > 0 && (
                    <span className='ml-3 text-text-gray-1'>
                        {t('words_title.upload_excel_hidden')}
                        <span className='ml-1'>{hiddenCount}</span>
                    </span>
                )}
            </div>
            <div className='mt-4'>
                {t('words_title.upload_excel_failed')}
                <span className='text-red-6 ml-1'>{invalidData.length}</span>
            </div>
            {pins.length > 0 && (
                <div className='mt-4'>
                    <p className='text-black-2 mb-2'>{t('words_title.imported_items_map')}</p>
                    <MultiPinMapPreview pins={pins} />
                </div>
            )}
            <div className='relative w-full overflow-x-auto mt-4'>
                <div className='flex bg-background-6 space-x-10 text-text-gray-1 text-[15px] font-semibold rounded-[4px]'>
                    <div className='w-20 pl-6 py-4.5'>
                        {t('words_title.count_row')}
                    </div>
                    <div className='flex-1 px-4 py-4.5'>{t('words_title.content_failed')}</div>
                </div>

                <div className='bg-white overflow-y-auto overflow-hidden'>
                    {
                        invalidData?.length > 0 && invalidData.map((item, index) => (
                            <>
                                <div key={index} className='flex space-x-10 hover:bg-gray-50 border-b border-background-2 rounded-[4px] text-text-normal text-[13px]'>
                                    <div className='w-20 pl-6 py-4.5'>{item?.no}</div>
                                    <div className='flex-1 px-4 py-4.5'>
                                        {item?.fieldsErr?.map((err, errIndex) => (
                                            <div key={errIndex}>
                                                {err}
                                                。
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        ))
                    }
                    {
                        invalidData?.length === 0 && (
                            <div className='flex py-4.5 border-b border-background-2 items-center justify-center rounded-[4px] text-text-normal text-[13px]'>
                                {t('words_title.no_result_after_import_excel')}
                            </div>
                        )
                    }
                </div>
            </div>

        </>
    );
});
